import React from "react";
import { SectionHeading } from "../../components/ui/SectionHeading";
import { CloudsLayer } from "../../components/ui/Decorations";
import { FAQS } from "../../data/mockData";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../../components/ui/accordion";

export default function FAQ() {
  return (
    <div>
      <section className="relative overflow-hidden pt-10 pb-4">
        <CloudsLayer />
        <div className="max-w-3xl mx-auto px-4 text-center relative z-10">
          <SectionHeading eyebrow="FAQ" title="Pertanyaan Umum" subtitle="Temukan jawaban seputar tiket, aktivitas, dan hari acara." />
        </div>
      </section>
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-4">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-white rounded-2xl border-4 border-white shadow-playful px-5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-display text-left text-sea-deep hover:no-underline py-4 text-base">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sea-deep/75 font-semibold pb-4">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
